import KeyValueItems from './KeyValueItems';
export type { KeyValueItemsProps } from './KeyValueItems';

export default KeyValueItems;
